export default __webpack_public_path__ + "static/media/nl.278155cb.svg";